import type { CommunicationRequest } from 'fhir/r4';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

import * as FHIRUtils from '../fhirutils';

export function build(
  patientId: string,
  practitionerId: string, // Author
  commCategoryCode: { code: string; display: string }, //custom: projectWell
  occurrenceDateTime: string,
  updatedBy: string,
  organization: string, // Organization.
  status: 'active' | 'completed' | 'on-hold' = 'active',
  taskId: string | undefined,
  weekNumber: string | undefined = undefined
): CommunicationRequest {
  const communicationRequestId = uuid();

  const commRequest: CommunicationRequest = {
    resourceType: 'CommunicationRequest',
    status: status,
    id: communicationRequestId,
    occurrenceDateTime: occurrenceDateTime,
    identifier: [
      {
        system: 'https://projectwell.io/fhir/identifiers/created-by',
        value: practitionerId,
      },
      {
        system: 'https://projectwell.io/fhir/orgid',
        value: organization,
      },
      {
        system: 'https://projectwell.io/fhir/identifiers/last-modified-by',
        value: practitionerId,
      },
    ],
    // extension: [
    //     url: 'https://projectwell.io/fhir/completed-date',
    //     valueString: '2023-06-19T16:21:37+00:00',
    category: [
      {
        coding: [
          {
            system: 'https://projectwell.io/fhir/communication-category',
            code: commCategoryCode.code,
            display: commCategoryCode.display,
          },
        ],
      },
    ],
    medium: [
      {
        coding: [
          {
            code: 'EMAILWRIT',
          },
        ],
      },
      {
        coding: [
          {
            code: 'SMSWRIT',
          },
        ],
      },
    ],
    subject: {
      reference: `Patient/${patientId}`,
    },
    recipient: [
      {
        reference: 'Patient/' + patientId,
      },
    ],
    authoredOn: moment().utc().format('YYYY-MM-DD'),
  };

  // if (medium) {
  //   participationModes.forEach((mode) => cr.addMedium(mode));
  //   let practitioners = assignedTo.split(',');
  //   practitioners.forEach((practitioner) =>
  //     flag.identifier.push({
  //       system: 'https://projectwell.io/fhir/identifiers/assigned-to',
  //       value: 'Practitioner/' + practitioner, // Practitioner Id
  if (taskId) {
    commRequest.identifier!.push({
      system: 'https://projectwell.io/fhir/identifiers/cancelled-task-id',
      value: taskId,
    });
  }
  if (weekNumber) {
    commRequest.identifier!.push({
      system: 'https://projectwell.io/fhir/identifiers/week-number',
      value: weekNumber, // for nutirtion tips week number
    });
  }
  return FHIRUtils.addUpdatedBy(commRequest, updatedBy);
}
